module.exports = __webpack_public_path__ + "static/img/mica-4.eb4d5cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mica-4.jpg
// module id = O9SK
// module chunks = 1